export default __webpack_public_path__ + "static/media/astronomy.26fbe212.jpg";